import { AccountDetailsStatusI } from "shared/lib/interfaces/account";
import { useFetchAccountDetails } from "@/api/routes/account/queries";

/**
 * GLE-8230: the account status the meeting-cancel notice reads. The
 * account-details drawer already holds it; the dialer widget, the session page
 * and catch-up mode render outside the drawer, so there it comes from the same
 * cached query the drawer uses. Nothing is fetched unless isEnabled says the
 * rep's current choice could cancel a meeting.
 */
export const useAccountStatusForMeetingNotice = ({
  accountStatus,
  campaignId,
  accountId,
  isEnabled,
}: {
  accountStatus: AccountDetailsStatusI | undefined;
  campaignId: string | undefined;
  accountId: string | undefined;
  isEnabled: boolean;
}): AccountDetailsStatusI | undefined => {
  const { data } = useFetchAccountDetails(
    campaignId,
    accountId,
    isEnabled && !accountStatus
  );

  return accountStatus ?? data?.data?.account_status;
};
